import { ILanguageStrings } from '../utils/languages/languages';

export interface IDiversityProps {
  nextStep: Function;
  previousStep: Function;
  handleChange?: Function;
  companyKey: string;
  initialState: IDiversitySubmitState;
  cachedResponse?: any;
  isAlreadyTagged?: boolean;
  taggedDate?: string;
  languageStrings: ILanguageStrings;
}

export interface IDiversityState {
  diversityList: IDiversityRow[];
  isContinueEnabled?: boolean;
  isModalOpened: boolean;
  readyToDelete?: number;
  isErrorDiversityList?: boolean;
  errorDiversityList?: string;
  loading?: boolean;
  diversityInstructions: string;
  radioGroupValue: string;
  wasDiversityFileUploaded?: boolean;
}

export interface IDiversityRow {
  level1Id?: number;
  level2Id?: number | null;
  hasSecondLevel?: boolean;
  isExpanded?: boolean;
  classification?: string;
  signedUrl?: string;
  isFilePushed?: boolean;
  file?: File;
  isErrorFile?: boolean;
  errorFile?: string;
  fileName: string;
  document?: string;
  isErrorCertificate?: boolean;
  errorCertificate?: string;
  startDate: string;
  isErrorStartDate?: boolean;
  errorStartDate?: string;
  expDate: string;
  isErrorExpDate?: boolean;
  errorExpDate?: string;
  ISCPUC?: string;
  referenceId?: string;
}

export interface IRowDiversityState {
  index: number;
  level1Id?: number;
  level2Id?: number | null;
  classification?: string;
  originalFileName?: string;
  document?: string;
  startDate: string;
  endDate: string;
  isErrorFile?: boolean;
  isErrorCertificate?: boolean;
  isErrorStartDate?: boolean;
  isErrorExpDate?: boolean;
  errorFile?: string;
  errorCertificate?: string;
  errorStartDate?: string;
  errorExpDate?: string;
  ISCPUC?: string;
  referenceId?: string;
  signedUrl?: string;
}

export interface IDiversitySubmitState {
  uploadCertificates: IRowDiversityState[];
  isContinueEnabled?: boolean;
  radioGroupValue?: string;
  taggedDate?: string;
}

export interface IDiversityFile {
  id: number;
  parentId?: number;
  iscpuc?: string;
  originalFileName?: string;
  startDate?: string;
  endDate?: string;
  certificateId?: string;
  classification?: string;
  secondLevel?: IDiversityFile[];
}

export interface IDiversityTagResponse {
  updatedDate: string;
  diversityFiles: IDiversityFile[];
}

const DiversityState: IDiversitySubmitState = {
  uploadCertificates: [],
  radioGroupValue: 'no',
  isContinueEnabled: false
};

export default DiversityState;
